@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.inviteHeader,
.shareHeader,
.socialHeader {
  @include md-sohne-medium;
  color: var(--dark-80);
  line-height: 120%;
  margin-bottom: 6px;
}

.content {
  padding: 40px !important;
  display: flex;
  flex-direction: column;

  [data-autopilot-system-redesign='on'] & {
    padding: 0 40px 35px 40px !important;
  }

  @include for-desktop-only {
    gap: 25px;
  }
  @include for-phone-only {
    gap: 30px;
  }

  .inviteInputContainer {
    display: flex;
    gap: 12px;
    @include for-phone-only {
      flex-direction: column;
    }

    .emailAddressesListContainer {
      @include input-border;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      min-height: 40px;
      position: relative;

      [data-autopilot-system-redesign='on'] & {
        padding: 0;
        min-height: 36px;

        > div {
          padding: 2px 10px;

          p {
            margin-top: 4px !important;
          }
        }
      }

      > div {
        padding: 6px 10px;
      }
    }
  }

  .shareContainer {
    .shareButtonsContainer {
      display: flex;
      gap: 5px;

      .urlContainer {
        border-radius: 6px;
        background: var(--light-100);
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.03), 0px 2px 5px 0px rgba(0, 0, 0, 0.07);
        padding: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        color: var(--dark-40);

        [data-autopilot-system-redesign='on'] & {
          box-shadow: none;
          border: 1px solid var(--dark-8);
          padding: 8px 10px;
          height: 36px;
        }
      }
    }

    .socialHeader {
      margin-top: 10px;
    }

    .socials {
      display: flex;
      gap: 10px;
      margin-top: 10px;

      .button {
        width: 100%;
      }
    }
  }
}

.freeEarned {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-radius: 15px;
  border: 1px solid rgba(182, 75, 248, 0.15);
  background: rgba(182, 75, 248, 0.1);

  .freeEarnedTop,
  .freeEarnedBottom {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 15px;
    gap: 20px;
  }

  .progressLine {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 5px;
    position: relative;
    height: 2px;
    margin: -4px 0;

    &::before {
      content: '';
      position: absolute;
      left: 50px;
      right: 50px;
      top: 50%;
      transform: translateY(-50%);
      height: 1px;
      background: var(--dark-15);
      z-index: 0;
    }
  }

  .progressMarker {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--light-100);
    border: 1px solid var(--dark-15);
    position: relative;
    z-index: 1;
    flex-shrink: 0;

    &.progressMarkerActive {
      background: #6a00ff;
      border-color: #6a00ff;
    }
  }

  .referralCount {
    gap: 4px;
  }

  .referralCount,
  .rewardAmount {
    display: flex;
    flex-direction: column;
    align-items: center;

    &.inactive {
      opacity: 0.4;
    }

    .rewardAmountTop {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-bottom: 5px;
    }

    .postsPerWeek {
      margin-bottom: -4px;
    }

    svg {
      path {
        stroke-width: 2;
      }
    }
  }
}

.payingMonthsEarned {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 10px;
  gap: 8px;
  background: rgba(182, 75, 248, 0.15);
}

.creditsReferralRewardsContainer {
  align-items: flex-end;
  align-self: stretch;
  background: rgba(182, 75, 248, 0.1);
  border: 1px solid rgba(182, 75, 248, 0.15);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;

  .header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .inviteLink {
    align-items: center;
    align-self: stretch;
    display: flex;
    gap: 10px;
  }

  .explanation {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    gap: 10px;
  }
}
